import React from "react";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { Icon, SemanticICONS } from "semantic-ui-react"
import IObservation from "../../interfaces/IObservation";

const getTextProps = (t: TFunction) => ({
    sending: t("Lähetetään havaintosovellukseen"),
    sended: t("Lähetetty havaintosovellukseen"),
    sendError: t("Lähetys havaintosovellukseen epäonnistui"),
});

interface NoteSubmitStatusProps {
    status?: "submitted" | "unsubmitted" | "submitError",
    className?: string;
    relatedObservation?: IObservation["id"];
};

export const NoteSubmitStatus: React.FC<NoteSubmitStatusProps> = ({
    className,
    status,
    relatedObservation
}) => {
    const texts = getTextProps(useTranslation().t);

    const icon: SemanticICONS = "paper plane";

    if (!status && relatedObservation) {
        status = "submitted"
    };

    if (!status) {
        return null
    };

    const statusText = {
        "submitted": texts.sended,
        "submitError": texts.sendError,
        "unsubmitted": texts.sending
    }[status];



    return (
        <p className={className}>
            <Icon name={icon} />
            {statusText}
        </p>
    )
}